import { useAuth } from "./auth";

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const { user, loading } = useAuth();

  // Read admin role from JWT app_metadata — same source of truth as
  // Edge Functions (requireAdminUser) and RLS (is_current_user_admin()).
  // No extra DB query needed; the JWT is already available client-side.
  const isAdmin = user?.app_metadata?.role === "admin";

  return { isAdmin: !!isAdmin, loading };
}
